export default __webpack_public_path__ + "static/media/mechs_vs_monsters.5f484628.svg";